
namespace Matrix.Workflow {

    export interface ClientFunctionGetModelResponse extends Serenity.ServiceResponse {
        Icon?: string;
        ActionCode?: string;
        WorkflowInstanceId?: number;
    }

    @Serenity.Decorators.registerClass('Matrix.Workflow.WorkflowQueueInvokeDialog')
    export class WorkflowQueueInvokeDialog extends Serenity.PropertyDialog<any, ClientFunctionGetModelResponse> {

        constructor(opt: ClientFunctionGetModelResponse) {
            super(opt);

            this.dialogTitle = this.options.ActionVerb || this.options.Title;
        }

        protected getPropertyItems() {
            return this.options.Parameters || [];
        }

        getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.width = 450;
            return opt;
        }

        then: () => void;

        public invoke(then?: () => void) {
            var request: ClientFunctionInvokeRequest = {};
            request.FunctionName = this.options.FunctionName;
            request.Params = {};
            this.propertyGrid.save(request.Params);
            for (var p of this.options.Parameters) {
                if (p.visible != null && !p.visible && p.defaultValue != null) {
                    request.Params[p.name] = p.defaultValue;
                }
            }

            request.CurrentAction = this.options.ActionCode;
            request.WorkflowInstanceId = this.options.WorkflowInstanceId;
            request.ParamTypes = {};
            for (var p of this.options.Parameters) {
                request.ParamTypes[p.name] = p.editorType as string;
                if ((p.editorType == "FileUpload" ||
                    p.editorType == "ImageUpload"))
                    request.Params[p.name] = request.Params[p.name] + ":" + (p.editorParams || {}).Source;
            }

            ClientFunctionTriggerView.Invoke(request, () => {
                Q.notifySuccess("The request has been queued.");
                then && then();
            });
        }

        okClickValidated() {
            this.invoke(() => {
                this.dialogClose();
                this.then && this.then();
            });
        }
    }
}